import $ from 'jquery';
import Globals from '@/helpers/globals';

const { $body } = Globals;

const Header = {
    init() {
        $body.on('click', () => this.handleBody());
        $body.on('click', '.js-menu-toggle', () => this.handleMenu());
        $body.on('click', '.js-header-search-toggle', e => this.handleSearch(e));
        $body.on('click', '.js-header-search-input', e => this.handleSearchInput(e));
    },

    handleMenu() {
        if (!$body.hasClass('menu-is-open')) $body.attr('data-scroll-position', window.scrollY);

        $body.toggleClass('menu-is-open');

        if (!$body.hasClass('menu-is-open')) {
            window.scrollTo(0, $body.attr('data-scroll-position'));
            $('.slick-slider').slick('setPosition', 0);
        }
    },

    handleSearch(e) {
        e.stopPropagation();

        $body.toggleClass('search-is-open');
        if ($body.hasClass('search-is-open')) $('.js-header-search-input').focus();
    },

    handleSearchInput(e) {
        e.stopPropagation();
    },

    handleBody() {
        if ($body.hasClass('search-is-open')) $body.removeClass('search-is-open');
    },
};

export default Header;
